import React from "react";
import clsx from "clsx";
import { Pagination as Pagin, PaginationItemType, type PaginationItemRenderProps, type PaginationProps } from "@nextui-org/pagination";
import Icon from "@react/widget/Icon";

interface Label {
  next?: string;
  prev?: string;
}
interface Props extends PaginationProps {
  label?: Label;
};

const Pagination:React.FC<Props> = ({className = "max-w-fit mx-auto", classNames = {}, showControls = true, page = 0, total = 0, initialPage, radius="full", color="default", label: {prev = "Prev", next = "Next"} = {}, renderItem, onChange = (page: number) => {}, ...props}) => {
  if(total < 2)
    return null;
  const p = page;
  const tl = total;
  const cns = Object.assign({
    base: clsx("px-0 py-2.5 -m-2.5 overflow-x-scroll scrollbar-hide mt-12 w-fit mx-auto"),
    wrapper: clsx("flex w-fit mx-auto gap-1 md:gap-4 text-sm font-semibolds [&>li]:inline-flex"),
    item: clsx("item-style min-w-min border flex justify-center items-center w-8 h-8 md:w-10 md:h-10 py-1 px-2 md:py-1.5 bg-white rounded-full", "transition-colors [&:not([data-disabled]):hover]:bg-hover [&:not([data-disabled])]:cursor-pointer"),
    cursor: clsx("cursor-style", "min-w-min z-10 flex justify-center items-center w-8 h-8 md:w-10 md:h-10 py-1 px-2 md:py-1.5 bg-green rounded-full"),
  }, classNames);

  const ri = ({ref, key, value, page, total, isActive, activePage, onNext, onPrevious, setPage, className}:PaginationItemRenderProps) => {
    var first = activePage===1,
      last = activePage===total;
    if (value === PaginationItemType.PREV) {
      return (
      <li key={key} className={clsx(className, "flex flex-nowrap md:w-auto px-4 md:gap-3")} data-disabled={first} role="button" onClick={() => onPrevious()}>
        <Icon name="arrow-left"/>
        <span className="hidden md:block">{prev}</span>
      </li>
      )
    }
  
    if (value === PaginationItemType.NEXT) {
      return (
        <li key={key} className={clsx(className, "flex flex-nowrap md:w-auto px-4 gap-3")} data-disabled={last} role="button" onClick={() => onNext()}>
        <span className="hidden md:block">{next}</span>
        <Icon name="arrow-right"/>
      </li>
      );
    }
  
    if (value === PaginationItemType.DOTS) {
      return (
        <li key={key} className={clsx(className, "data-[disabled=true]:text-default-300 data-[disabled=true]:pointer-events-none shadow-sm bg-default-100 [&amp;[data-hover=true]:not([data-active=true])]:bg-default-200 active:bg-default-300")} onClick={() => setPage(page)}>
          <svg aria-hidden="true" fill="none" height="1em" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="1em" className="group-hover:hidden group-data-[focus-visible=true]:hidden ellipsis-style"><circle cx="12" cy="12" fill="currentColor" r="1"></circle><circle cx="19" cy="12" fill="currentColor" r="1"></circle><circle cx="5" cy="12" fill="currentColor" r="1"></circle></svg>
          <svg aria-hidden="true" fill="none" focusable="false" height="1em" role="presentation" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="1em" className="hidden group-hover:block group-data-[focus-visible=true]:block data-[before=true]:rotate-180 forwardIcon-style"><path d="M13 17l5-5-5-5"></path><path d="M6 17l5-5-5-5"></path></svg>
        </li>
      );
    }
    return (
      <li ref={ref} key={key} className={clsx(className)} onClick={() => setPage(value)}>{value}</li>
    );
  };

  return (
    <Pagin className={className} classNames={cns} showControls={showControls} page={p} total={tl} initialPage={initialPage} radius={radius} renderItem={renderItem??ri} onChange={p => onChange( p )} {...props}/>
  );
}

export default Pagination;